import React, { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, useTexture, Html } from '@react-three/drei';
import * as THREE from 'three';
import { LoadingOutlined, WarningOutlined } from '@ant-design/icons';

// Inner component for the 360 sphere
const PanoramaSphere = ({ imageUrl }) => {
    const texture = useTexture(imageUrl);
    return (
        <mesh>
            <sphereGeometry args={[5, 60, 40]} />
            <meshBasicMaterial map={texture} side={THREE.BackSide} />
        </mesh>
    );
};

// Fallback loader component
const Loader = () => (
    <Html center>
        <div style={{ color: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, whiteSpace: 'nowrap' }}>
            <LoadingOutlined style={{ fontSize: 24 }} />
            <span style={{ fontSize: 12, textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>Loading 360...</span>
        </div>
    </Html>
);

const PanoramaViewer = ({ imageUrl, autoRotate = false }) => {
    if (!imageUrl) return null;

    return (
        <div style={{ width: '100%', height: '100%', position: 'relative', background: '#000' }}>
            <Canvas camera={{ position: [0, 0, 0.1] }}>
                <Suspense fallback={<Loader />}>
                    <PanoramaSphere imageUrl={imageUrl} />
                </Suspense>
                <OrbitControls
                    enableZoom={false}
                    enablePan={false}
                    enableDamping
                    dampingFactor={0.1}
                    rotateSpeed={-0.5}
                    autoRotate={autoRotate}
                />
            </Canvas>
        </div>
    );
};

export default PanoramaViewer;
